import React from "react";
import styles from "./styles.module.css";
import { FormattedMessage } from "react-intl";
import CustomSelect from "../CustomSelect";
import { LuChevronDown } from "react-icons/lu";
const FormField = ({
  formType = "",
  label,
  value,
  name,
  type,
  id,
  handleChange,
  options = [],
  rules,
  selectType,
  customSelectActive,
  handleCustomClick,
  selectStyle = {},
  deepDisable = false,
  ...props
}) => {
  const validationError =
    rules?.required &&
    rules?.hasSubmitted &&
    (!value?.trim() || rules?.hasError);
  return (
    <div
      className={`${styles["container"]} 
      ${type == "radio" ? styles["container-radio"] : ""}
      ${type == "select" ? styles["container-select"] : ""}
      ${deepDisable ? styles["deep-disable"] : ""}`}
    >
      <label
        className={`${
          (type === "textarea" || formType == "create") &&
          styles["create-label"]
        } ${formType == "coco" && styles["coco-label"]}`}
        htmlFor={name}
      >
        {label}
        {rules?.required && (
          <span className={styles["label-star"]}>
            *{" "}
            {rules?.hasSubmitted && (!value?.trim() || rules?.hasError) && (
              <span className={styles["label-reuired"]}>
                {rules?.message || "Required"}
              </span>
            )}
          </span>
        )}
      </label>
      {type == "select" ? (
        <div className={styles["select-container"]}>
          <CustomSelect
            options={options}
            placeHolder={props.placeHolder || "-- select an option --"}
            defaultValue={value || null}
            value={value}
            onChange={(option) => {
              // normalize to the same event shape the rest of the app expects
              const syntheticEvent = {
                target: { name: name, value: option ? option.value : "" },
              };
              if (handleChange) handleChange(syntheticEvent);
            }}
            className={`${
              formType == "create" ? styles["create-label-select"] : ""
            } ${validationError ? styles["form-field-error"] : ""} ${
              deepDisable ? styles["deep-disable"] : ""
            }`}
            variant={
              formType == "content-library"
                ? "select-secondary"
                : formType == "coco"
                ? "select-coco"
                : ""
            }
            name={name}
            onToggle={handleCustomClick}
            {...(props || {})}
          />
        </div>
      ) : type == "custom-select" ? (
        <div className={styles["custom-select-container"]}>
          <CustomSelect
            options={options}
            placeHolder={props.placeHolder || "-- select an option --"}
            defaultValue={value || null}
            value={value}
            onChange={(option) => {
              const syntheticEvent = {
                target: { name: name, value: option ? option.value : "" },
              };
              if (handleChange) handleChange(syntheticEvent);
            }}
            className={`${styles["content-library-select"]} ${
              deepDisable ? styles["deep-disable"] : ""
            }`}
            name={name}
            onToggle={handleCustomClick}
            {...(props || {})}
          />

          <LuChevronDown
            size={24}
            className={
              customSelectActive ? styles["arrow-up"] : styles["arrow-down"]
            }
          />
        </div>
      ) : type === "textarea" ? (
        <textarea
          className={`${styles["support-input"]} ${styles["input-error"]}`}
          id={id}
          name={name}
          value={value}
          onChange={handleChange}
          required
          {...props}
        />
      ) : (
        <input
          className={`${formType == "create" && styles["create-input"]} ${
            validationError && styles["form-field-error"]
          } ${deepDisable ? styles["deep-disable"] : ""}`}
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={handleChange}
          required
          {...props}
          checked={value}
        />
      )}
    </div>
  );
};

export default FormField;
